import { createReducer } from "reduxsauce";
import { AttributionReportTypes as Types } from "../actions";
import storeInitialState from "../store/initial-state";

export const INITIAL_STATE = storeInitialState.attributionReport;

export const getAvailabilityRequest = state => ({
  ...state,
  loadingAvailability: true,
});
export const getAvailabilityFailure = state => ({
  ...state,
  loadingAvailability: false,
});
export const getAvailabilitySuccess = (state, action) => ({
  ...state,
  availability: action.availability,
  loadingAvailability: false,
});

export const getReportRequest = state => ({
  ...state,
  loadingReport: true,
  reportUnavailable: false,
});
// The API answers a cycle the caller may not read with a bare 404, so a
// failure here is indistinguishable from "not published". Recording it is
// what lets the screen say so — without it the screen has only "loading"
// and "loaded", and a refused report sits on the skeleton forever.
export const getReportFailure = state => ({
  ...state,
  loadingReport: false,
  reportUnavailable: true,
});
export const getReportSuccess = (state, action) => ({
  ...state,
  report: action.reportData.report,
  config: action.reportData.config,
  loadingReport: false,
  reportUnavailable: false,
});

export const getStudentsRequest = state => ({
  ...state,
  loadingStudents: true,
});
export const getStudentsFailure = state => ({
  ...state,
  loadingStudents: false,
});
export const getStudentsSuccess = (state, action) => ({
  ...state,
  students: action.studentsData,
  loadingStudents: false,
});
export const clearStudents = state => ({
  ...state,
  students: null,
});

export const getTimelineRequest = state => ({
  ...state,
  loadingTimeline: true,
  timeline: null,
});
export const getTimelineFailure = state => ({
  ...state,
  loadingTimeline: false,
});
export const getTimelineSuccess = (state, action) => ({
  ...state,
  timeline: action.timeline,
  loadingTimeline: false,
});
export const clearTimeline = state => ({
  ...state,
  timeline: null,
  loadingTimeline: false,
});

export const updateConfigRequest = state => ({
  ...state,
  savingConfig: true,
});
export const updateConfigFailure = state => ({
  ...state,
  savingConfig: false,
});
export const updateConfigSuccess = (state, action) => ({
  ...state,
  config: action.config,
  savingConfig: false,
});

export const nextStepsSuccess = (state, action) => ({
  ...state,
  report: state.report
    ? { ...state.report, next_steps: action.nextSteps }
    : state.report,
  savingNextSteps: false,
});
export const nextStepsRequest = state => ({
  ...state,
  savingNextSteps: true,
});
export const nextStepsFailure = state => ({
  ...state,
  savingNextSteps: false,
});

export const HANDLERS = {
  [Types.GET_ATTRIBUTION_AVAILABILITY_REQUEST]:
    getAvailabilityRequest,
  [Types.GET_ATTRIBUTION_AVAILABILITY_FAILURE]:
    getAvailabilityFailure,
  [Types.GET_ATTRIBUTION_AVAILABILITY_SUCCESS]:
    getAvailabilitySuccess,
  [Types.GET_ATTRIBUTION_REPORT_REQUEST]: getReportRequest,
  [Types.GET_ATTRIBUTION_REPORT_FAILURE]: getReportFailure,
  [Types.GET_ATTRIBUTION_REPORT_SUCCESS]: getReportSuccess,
  [Types.GET_ATTRIBUTION_STUDENTS_REQUEST]: getStudentsRequest,
  [Types.GET_ATTRIBUTION_STUDENTS_FAILURE]: getStudentsFailure,
  [Types.GET_ATTRIBUTION_STUDENTS_SUCCESS]: getStudentsSuccess,
  [Types.CLEAR_ATTRIBUTION_STUDENTS]: clearStudents,
  [Types.GET_ATTRIBUTION_TIMELINE_REQUEST]: getTimelineRequest,
  [Types.GET_ATTRIBUTION_TIMELINE_FAILURE]: getTimelineFailure,
  [Types.GET_ATTRIBUTION_TIMELINE_SUCCESS]: getTimelineSuccess,
  [Types.CLEAR_ATTRIBUTION_TIMELINE]: clearTimeline,
  [Types.UPDATE_ATTRIBUTION_CONFIG_REQUEST]: updateConfigRequest,
  [Types.UPDATE_ATTRIBUTION_CONFIG_FAILURE]: updateConfigFailure,
  [Types.UPDATE_ATTRIBUTION_CONFIG_SUCCESS]: updateConfigSuccess,
  [Types.CREATE_ATTRIBUTION_NEXT_STEP_REQUEST]: nextStepsRequest,
  [Types.UPDATE_ATTRIBUTION_NEXT_STEP_REQUEST]: nextStepsRequest,
  [Types.DELETE_ATTRIBUTION_NEXT_STEP_REQUEST]: nextStepsRequest,
  [Types.REORDER_ATTRIBUTION_NEXT_STEPS_REQUEST]: nextStepsRequest,
  [Types.ATTRIBUTION_NEXT_STEPS_SUCCESS]: nextStepsSuccess,
  [Types.ATTRIBUTION_NEXT_STEPS_FAILURE]: nextStepsFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
